module.exports = "https://dev.stanwinstonschool.com/3-about-us-desktop.6a3257f9fffa84ed63ed45d90c376141.jpg";